import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: #000;
`;
export const ContentsWrapper = styled.div`
  flex: 1 1 0%;
  height: calc(100% - 80px);
  margin: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.transparentShadow};
`;
export const Contents = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${ColorSF2.white};
  border-radius: 5px;
  @media (max-width: 600px) {
    width: auto;
  }
`;
export const Header = styled.div`
  width: 100%;
  height: 80px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  @media (max-height: 740px) {
    height: 50px;
    font-size: 18px;
  }
  @media (max-height: 600px) and (orientation: landscape) {
    height: 30px;
    font-size: 16px;
  }
`;
export const Content = styled.div``;
export const Body = styled.div`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-height: 600px) and (orientation: landscape) {
    flex-direction: row;
    padding: 20px;
  }
`;
export const QRCode = styled.img`
  width: 260px;
  height: 260px;
  @media (max-height: 740px) {
    width: 180px;
    height: 180px;
  }
  @media (max-height: 600px) {
    width: 120px;
    height: 120px;
  }
`;
export const NoData = styled.div`
  width: 240px;
  height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: ${ColorSF2.lightGray};
  @media (max-height: 600px) and (orientation: landscape) {
    height: 160px;
  }
`;
export const NoDataTitle = styled.div`
  width: 167px;
  font-size: 14px;
  @media (max-height: 600px) {
    font-size: 12px;
  }
`;
export const IssueButton = styled.div`
  width: 200px;
  height: 50px;
  border-radius: 5px;
  background-color: ${ColorSF2.navyBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${ColorSF2.white};
  @media (max-height: 600px) {
    font-size: 12px;
    width: 140px;
    height: 30px;
  }
`;
export const UpdateExpire = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;
  margin: 0 10px;
  @media (max-height: 600px) {
    font-size: 10px;
  }
`;
export const UpdateExpireFormWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const UpdateExpireTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const UpdateExpireForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
export const UpdateExpireInput = styled.input`
  width: 160px;
  height: 36px;
  font-size: 16px;
  padding: 10px;
  background-color: ${props => props.error && '#faa'};
  @media (max-height: 600px) {
    height: 30px;
    font-size: 14px;
  }
`;
export const UpdateExpireButton = styled.div`
  width: 100px;
  height: 30px;
  border-radius: 5px;
  background-color: ${ColorSF2.navyBlue};
  color: ${ColorSF2.white};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px;
  @media (max-height: 600px) {
    font-size: 12px;
    width: 80px;
    height: 28px;
  }
`;
export const DeleteQRCodeButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
export const DeleteQRCodeButton = styled.div`
  width: 200px;
  height: 50px;
  border-radius: 5px;
  background-color: ${ColorSF2.red};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  color: ${ColorSF2.white};
  @media (max-height: 600px) {
    font-size: 12px;
    width: 140px;
    height: 30px;
  }
`;
